<script>
import { defineComponent } from 'vue';
import { CancelablePromise } from '@/shared/legacy/api/utils/cancelable-promise';
import { normalizeChildren } from '@/shared/legacy/lib/util/component-helpers';
import { awaitPromiseSymbol } from './symbols';

/**
 * @deprecated use useIslandLoader instead
 */
export default defineComponent({
  name: 'LoadingState',
  provide() {
    return {
      [awaitPromiseSymbol]: this.addPromise
    };
  },
  props: {
    disableAutoReset: Boolean
  },
  emits: ['loaded'],
  data() {
    return {
      loading: true,
      promises: []
    };
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$emit('loaded');
      }
    },
    promises: {
      handler(promises) {
        this.promise?.cancel();
        if (!this.loading) {
          return;
        }

        const promise = CancelablePromise.resolve(Promise.all(promises))
          .then(() => {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                if (promise.canceled) {
                  return reject();
                }
                resolve();
              }, 250);
            });
          })
          .finally(() => {
            if (promise.canceled) {
              return;
            }
            this.loading = false;
          });

        this.promise = promise;
      },
      deep: true
    },
    $route() {
      if (this.disableAutoReset) {
        return;
      }
      this.reset();
    }
  },
  methods: {
    addPromise(promise) {
      this.promises.push(promise);
      return promise;
    },
    reset() {
      this.loading = true;
      this.promises = [];
    }
  },
  render() {
    const children = normalizeChildren(this, {
      loading: this.loading,
      reset: this.reset
    });
    return children[0];
  }
});
</script>

<i18n lang="json">{}</i18n>
